import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatCompactNumber } from "@/lib/api";
import { imageForCity, IMG } from "@/lib/images";
import PageBanner from "@/components/common/PageBanner";

export default function Cities() {
  const [cities, setCities] = useState([]);
  useEffect(() => { api.get("/public/cities").then((r) => setCities(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="cities-page" className="bg-[var(--bone)]">
      <PageBanner
        eyebrow="National Footprint"
        title="India's mall map —"
        italicWord="city by city."
        kicker="Premium catchments in every Tier-1 metro and the most ambitious Tier-2 cities. Click any city to see its malls and live inventory."
        image={IMG.delhi}
        testId="cities-banner"
      />
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-[var(--border)]">
        {cities.map((c, idx) => (
          <motion.div
            key={c.city}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (idx % 8) * 0.05 }}
            className="bg-[var(--bone)] group"
          >
            <Link to={`/cities/${encodeURIComponent(c.city)}`} className="block" data-testid={`city-card-${c.city}`}>
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={imageForCity(c.city) || c.hero_image} alt={c.city} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 img-luxe" loading="lazy" />
                <div className="absolute inset-0 hero-overlay" />
                <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.25em] text-white/85">
                  {c.tier} · {c.state}
                </div>
                <div className="absolute bottom-5 left-5 right-5 text-white">
                  <div className="font-serif-display text-3xl lg:text-4xl">{c.city}</div>
                  <div className="mt-1 text-[10px] uppercase tracking-[0.25em] text-[var(--gold-light)]">
                    {c.mall_count} malls · {formatCompactNumber(c.monthly_footfall)}/mo
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
